var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"d-block mx-auto",class:_vm.className,attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('obClick')}}},[_vm._t("default",function(){return [_vm._v("Button")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }